import { Component, Inject, InjectionToken } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { CereriService } from "src/app/components/cereri/cereri.service";
import { AuthService } from "src/app/services/auth.service";
import { DialogService } from "src/app/utils/dialog.service";

@Component({
  selector: "app-open-uploaded-files",
  templateUrl: "./open-uploaded-files.component.html",
  styleUrls: ["./open-uploaded-files.component.scss"],
})
export class OpenUploadedFilesComponent {
  passedRequestId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<OpenUploadedFilesComponent>,
    private cereriService: CereriService,
    private authService: AuthService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) {
    console.log(data);
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }
  getDocumentTypeKeys(): string[] {
    return this.data ? Object.keys(this.data.documente) : [];
  }

  getDocumentKeys(docTypeKey: string): string[] {
    return this.data
      ? Object.keys(this.data.documente[docTypeKey].documente)
      : [];
  }
}
